import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { fetchLessons } from '../lessons/actions';
import ChapterEditPage from './ChapterEditPage';
import Lessons from '../lessons/Lessons';
import Loading from '../../common/components/Loading';

class Chapter extends Component {
  componentDidMount() {
    const { dispatch, match } = this.props;

    dispatch(fetchLessons(match.params.courseId, match.params.chapterId));
  }
  render() {
    const { chaptersLoaded, lessonsLoaded, match } = this.props;

    if (!lessonsLoaded || !chaptersLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={ChapterEditPage} />
        <Route path={`${match.path}/lessons`} component={Lessons} />
        <Redirect to={`/courses/${match.params.courseId}`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    chaptersLoaded: state.courses.chapters.get('loaded'),
    lessonsLoaded: state.courses.lessons.get('loaded'),
  };
};

export default connect(mapStateToProps)(Chapter);



// WEBPACK FOOTER //
// ./src/courses/chapters/Chapter.js